// Share aside tooltip initialization
document.addEventListener('turbo:frame-load', function(event) {
  if (event.target.id === 'aside') {
    const asideContent = event.target.innerHTML;
    if (asideContent.includes('<h3>Share</h3>')) {
      // Remove any tooltip initialization code, as global initialization is now handled in application.js.
    }
  }
}); 